import React from 'react';
import { Layout } from 'react-admin';

import CustomAppBar from './CustomAppBar';
import Menu from './CustomMenuItem';
import CustomSideBar from './CustomSlideBar.styles';

const CustomLayout = (props) => (
  <Layout
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    appBar={CustomAppBar}
    sidebar={CustomSideBar}
    menu={Menu}
  />
);

export default CustomLayout;
